import { coverPicks } from "@/mocks/navData";

export default function CoverPicks() {
  return (
    <section id="cover" className="scroll-mt-20 bg-[#f4ebd9]">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col justify-between gap-6 sm:flex-row sm:items-end">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] text-[#b0843f]">
              <i className="ri-image-2-line text-sm"></i>
              封面精选
            </span>
            <h2 className="mt-4 text-3xl font-bold leading-tight text-[#2a2016] md:text-4xl">
              别急着点，先挑顺眼的封面
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-[#6b5d48]">
            编辑手记：这周先把「看得懂前因、接得上续集」的整理放前排。
            封面只是引子，点进去才是完整入口，看完记得回来收编号。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {coverPicks.map((pick) => (
            <a
              key={pick.id}
              href="#index"
              className="group relative block cursor-pointer overflow-hidden rounded-2xl border border-[#ead9bd]"
            >
              <div className="relative aspect-[3/4] w-full overflow-hidden">
                <img
                  src={pick.cover}
                  alt={pick.title}
                  title={pick.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1f1609]/80 via-[#1f1609]/10 to-transparent"></div>
                <span className="absolute left-3 top-3 rounded-full bg-[#e4562b] px-3 py-1 text-xs font-semibold text-white">
                  {pick.badge}
                </span>
                <span className="absolute right-3 top-3 flex h-9 w-9 translate-y-1 items-center justify-center rounded-full bg-white/90 text-[#2a2016] opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                  <i className="ri-arrow-right-up-line text-lg"></i>
                </span>
                <div className="absolute inset-x-0 bottom-0 p-5">
                  <h3 className="text-lg font-bold leading-snug text-white">{pick.title}</h3>
                  <p className="mt-2 text-xs text-white/70">{pick.meta}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}